import React from 'react';
import { Types } from 'mongoose';
import { union } from 'lodash';

import '../index.css';

import InputDropdown from '../../../../../../bergmannsoft/components/Widgets/Forms/InputDropdown';

const allId = Types.ObjectId().toString();
const nothingId = Types.ObjectId().toString();
const specialDropdownItems = [
  { _id: nothingId, name: 'Nenhum', value: '', type: '' },
  { _id: allId, name: 'Todos', value: '', type: '' },
];

const ErrorLogsDropdown = (props) => {
  const {
    checkedOptions,
    setCheckedOptions,
    options,
    title,
    placeholder,
    setSelectedOptions,
  } = props;
  const dropdownOptions = union(specialDropdownItems, options);

  const updateSpecialOption = (lastCommand, hasAll, hasNothing, value) => {
    if (hasAll) {
      if (value.length < checkedOptions.length) {
        const newOptions = value.filter(
          (option) =>
            option !== nothingId.toString() && option !== allId.toString()
        );
        setSelectedOptions(newOptions);
        setCheckedOptions(newOptions);
        return;
      }

      const filteredOptions = dropdownOptions.filter(
        ({ _id }) => _id !== nothingId
      );

      const newOptions = filteredOptions.map(({ _id }) => _id);
      setCheckedOptions(newOptions);

      const newVariablesFormatted = filteredOptions
        .filter(({ _id }) => _id !== allId)
        .map(({ _id, type }) => _id || type);
      setSelectedOptions(newVariablesFormatted);
    }

    if (hasNothing && lastCommand === nothingId) {
      setSelectedOptions([]);
      setCheckedOptions([nothingId]);
    } else if (
      checkedOptions.find((option) => option === nothingId.toString())
    ) {
      if (value.find((option) => option === allId.toString())) {
        const filteredOptions = dropdownOptions.filter(
          ({ _id }) => _id !== nothingId
        );
        const newOptions = filteredOptions.map(({ _id }) => _id);
        setCheckedOptions(newOptions);
      } else {
        setCheckedOptions(
          value.filter((option) => option !== nothingId.toString())
        );
      }
    }

    if (
      !hasNothing &&
      !hasAll &&
      lastCommand !== hasAll &&
      lastCommand !== hasNothing
    ) {
      setSelectedOptions([]);
      setCheckedOptions([]);
    }
  };

  const updateCommonOption = (value, hasAll, hasNothing) => {
    const filteredOptions = dropdownOptions.filter(
      ({ _id }) => _id !== nothingId && _id !== allId
    );
    let newOptions = value
      .map((id) => {
        const newValue = filteredOptions.find(({ _id }) => _id === id);

        if (newValue) {
          const { _id, type } = newValue;
          return _id || type;
        }
        return null;
      })
      .filter(Boolean);

    if (hasAll) {
      const count = dropdownOptions.length - 2 - value.length - 1;
      if (count < dropdownOptions.length - 2) {
        newOptions = newOptions.filter((v) => v !== 'Todos');
        value = value.filter((v) => v !== allId);
      }
    } else if (hasNothing) {
      newOptions = newOptions.filter((v) => v !== 'Nenhum');
      value = value.filter((v) => v !== nothingId);
    } else if (value.length === dropdownOptions.length - 2) {
      value = [allId, ...value];
    }
    setCheckedOptions(value);
    setSelectedOptions(newOptions);
  };

  const onChangeVariablesDropdown = (value) => {
    const lastCommand = value[value.length - 1];
    const hasAll =
      checkedOptions.find((v) => v === allId) || value.find((v) => v === allId);
    const hasNothing =
      checkedOptions.find((v) => v === nothingId) ||
      value.find((v) => v === nothingId);

    if (hasAll || hasNothing) {
      updateSpecialOption(
        lastCommand,
        value.find((v) => v === allId),
        value.find((v) => v === nothingId),
        value
      );
    } else {
      updateCommonOption(
        value,
        value.find((v) => v === allId),
        value.find((v) => v === nothingId)
      );
    }
  };

  return (
    <div className="error-logs-page-by-dropdown">
      <span>{title}:</span>
      <InputDropdown
        className="settings-content-modal-input"
        placeholder={placeholder}
        dropdownItemsList={dropdownOptions}
        dropdownItemsChecked={checkedOptions}
        onChange={onChangeVariablesDropdown}
        useCheckbox
        styleWidth={200}
      />
    </div>
  );
};

export default ErrorLogsDropdown;
